/**
 * Decorative Sports Elements component for Friends page
 * Extracted from app/friends.tsx
 */

import React from 'react'
import { View } from 'react-native'
import Svg, { Circle, Path, Line, Rect } from 'react-native-svg'
import { decorativeElementsStyles as styles } from './DecorativeElements.styles'

export const DecorativeElements: React.FC = () => {
  return (
    <View style={styles.decorativeElements}>
      {/* Soccer Ball */}
      <View style={[styles.sportsDrawing, { top: '10%', left: '10%' }]}>
        <Svg width="40" height="40" viewBox="0 0 40 40">
          <Circle
            cx="20"
            cy="20"
            r="18"
            fill="rgba(255,255,255,0.1)"
            stroke="rgba(255,255,255,0.2)"
            strokeWidth="2"
          />
          <Path
            d="M20 2 Q30 8 35 20 Q30 32 20 38 Q10 32 5 20 Q10 8 20 2"
            fill="none"
            stroke="rgba(255,255,255,0.15)"
            strokeWidth="1"
          />
          <Path
            d="M20 2 Q30 8 35 20 Q30 32 20 38"
            fill="none"
            stroke="rgba(255,255,255,0.1)"
            strokeWidth="1"
          />
          <Path
            d="M20 2 Q10 8 5 20 Q10 32 20 38"
            fill="none"
            stroke="rgba(255,255,255,0.1)"
            strokeWidth="1"
          />
        </Svg>
      </View>

      {/* Trophy */}
      <View style={[styles.sportsDrawing, { top: '20%', left: '85%' }]}>
        <Svg width="25" height="35" viewBox="0 0 25 35">
          <Circle
            cx="12.5"
            cy="25"
            r="8"
            fill="rgba(255,255,255,0.1)"
            stroke="rgba(255,255,255,0.2)"
            strokeWidth="2"
          />
          <Path
            d="M7 8 L12.5 17 L18 8"
            fill="none"
            stroke="rgba(255,255,255,0.15)"
            strokeWidth="2"
          />
          <Circle
            cx="12.5"
            cy="25"
            r="4"
            fill="none"
            stroke="rgba(255,255,255,0.15)"
            strokeWidth="1"
          />
        </Svg>
      </View>

      {/* Stopwatch */}
      <View style={[styles.sportsDrawing, { top: '40%', left: '90%' }]}>
        <Svg width="30" height="35" viewBox="0 0 30 35">
          <Circle
            cx="15"
            cy="20"
            r="12"
            fill="rgba(255,255,255,0.1)"
            stroke="rgba(255,255,255,0.2)"
            strokeWidth="2"
          />
          <Rect
            x="12"
            y="5"
            width="6"
            height="4"
            fill="rgba(255,255,255,0.15)"
          />
          <Line
            x1="15"
            y1="20"
            x2="15"
            y2="12"
            stroke="rgba(255,255,255,0.15)"
            strokeWidth="2"
          />
          <Line
            x1="15"
            y1="20"
            x2="20"
            y2="20"
            stroke="rgba(255,255,255,0.15)"
            strokeWidth="1"
          />
        </Svg>
      </View>
    </View>
  )
}

